import RiskTolerance from '@advisor/models/store/riskTolerance/index';
import exceptionHandler from '@advisor/util/exceptionHandler';
import RwRiskToleranceService from '@advisor/rwSdk/RiskToleranceService';
import RwCloudConvertService from '@advisor/rwSdk/CloudConvertService';

const stateObj = () => new RiskTolerance();
const getters = {};
const actions = {
  async getQuestions({commit}, riaId) {
    let response;

    try {
      response = await RwRiskToleranceService.getQuestionnaireByRia({
        riaId,
      }).catch((error) => {
        throw error;
      });

      response = {data: response};

      commit('SET_QUESTION_DATA', response.data.data);

      return response;
    } catch (error) {
      return exceptionHandler.handleGenericException('riskTolerance.getQuestions', error);
    }
  },
  async saveRiskToleranceQuestionnaire({commit}, payload) {
    let response;

    try {
      const {riaId} = payload;
      const {riskToleranceId, shrinkageFactor, questions} = payload.data;
      const options = {riaId, riskToleranceId, shrinkageFactor, questions};

      response = await RwRiskToleranceService.postQuestionnaireByRia(options).catch((error) => {
        throw error;
      });

      response = {data: response};

      commit('SET_QUESTION_DATA', response.data.data);

      return response;
    } catch (error) {
      return exceptionHandler.handleGenericException('riskTolerance.saveRiskToleranceQuestionnaire', error);
    }
  },
  async restoreRTQ({commit}, riaId) {
    let response;

    try {
      response = await RwRiskToleranceService.postRestoreQuestionnaire({
        riaId,
      }).catch((error) => {
        throw error;
      });

      commit('SET_QUESTION_DATA', response.data);

      return response;
    } catch (error) {
      return exceptionHandler.handleGenericException('riskTolerance.restoreRTQ', error);
    }
  },
  async downLoadRTQClientHistoryFile(_, payload) {
    try {
      const response = await RwCloudConvertService.postHtmlToPdf(payload).catch((error) => {
        throw error;
      });
      const sdkResponse = {data: response};

      return sdkResponse;
    } catch (error) {
      return exceptionHandler.handleGenericException('riskTolerance.downLoadRTQClientHistoryFile', error);
    }
  },
};
const mutations = {
  SET_QUESTION_DATA(state, payload) {
    state.questionnaire = payload;
  },
};

export default {
  namespaced: true,
  state: stateObj,
  getters,
  actions,
  mutations,
};
